import { defineMessages } from "react-intl";

import {
	ableToSpiroergometryMessages,
	achievedMaxCapacityMessages,
	betaBlockerMessages,
	validator
} from "lib/build/forms/htx/current-cardiological-state/cardiopulmonaryStressTest";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	cardiopulmonaryStressTest: {
		id: "form.cardiopulmonary_stress_test",
		defaultMessage: "Spiroergometria"
	},
	ableToSpiroergometry: {
		id: "form.cardiopulmonary_stress_test.able_to_spiroergometry",
		defaultMessage:
			"Beteg állapota spiroergometriás vizsgálat elvégzésére alkalmas?"
	},
	betaBlocker: {
		id: "form.cardiopulmonary_stress_test.beta_blocker",
		defaultMessage: "Béta blokkoló hatásban történt vizsgálat?"
	},
	achievedMaxCapacity: {
		id: "form.cardiopulmonary_stress_test.achieved_max_capacity",
		defaultMessage: "Maximális terhelést elérte (RER>1,05)?"
	},
	vo2: {
		id: "form.cardiopulmonary_stress_test.vo2",
		defaultMessage: "Vo2"
	}
});

const fields: { [key: string]: FieldData } = {
	ableToSpiroergometry: {
		type: "field",
		path: ["ableToSpiroergometry"],
		label: messages.ableToSpiroergometry,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: ableToSpiroergometryMessages }
		}
	},
	betaBlocker: {
		type: "field",
		path: ["value", "betaBlocker"],
		label: messages.betaBlocker,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: betaBlockerMessages }
		}
	},
	achievedMaxCapacity: {
		type: "field",
		path: ["value", "achievedMaxCapacity"],
		label: messages.achievedMaxCapacity,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: achievedMaxCapacityMessages }
		}
	},
	vo2: {
		type: "field",
		path: ["value", "vo2"],
		label: messages.vo2,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.ableToSpiroergometry }] },
		{ columns: [{ width: 12, field: fields.betaBlocker }] },
		{ columns: [{ width: 12, field: fields.achievedMaxCapacity }] },
		{ columns: [{ width: 12, field: fields.vo2 }] }
	]
};

export const node: LeafNode = {
	id: "cardiopulmonaryStressTest",
	value: {
		title: messages.cardiopulmonaryStressTest,
		validator,
		fieldset,
		isImportant: true
	}
};
